import InstantHome from "./views/InstantHome.vue";
import InstantSpins from "./views/InstantSpins.vue";
import Exports from "../views/Exports.vue";
import Chat from "../views/Chat.vue";

export const instantRoutes = [
  {
    path: "/:lang?/:skinFilt(\\d+)?/instant",
    component: InstantHome,
    meta: { requiresAuth: true, hiddenBreadcrumb: true, section: "instant" },
    name: "InstantHome",
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/instant/spins",
    name: "InstantSpinsPage",
    component: InstantSpins,
    meta: { requiresAuth: true, section: "instant" },
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/instant/export",
    name: "InstantExportPage",
    component: Exports,
    meta: { requiresAuth: true, section: "instant" },
  },
  {
    path: "/:lang/:skinFilt(\\d+)?/instant/chat",
    component: Chat,
    name: "InstantChatPage",
    meta: {
      requiresAuth: true,
      showOverlay: true,
      section: "instant",
    },
  },
];